// Reset form hash after initialization to prevent false "unsaved changes" warnings
// This fixes a bug where lazy-loaded forms trigger dirty state on scroll into view
document.addEventListener('onFormieInit', (e) => {
  const form = e.detail.form
  if (form.formTheme) {
    setTimeout(() => form.formTheme.updateFormHash(), 100)
  }
})

// Update Formie page progress
document.addEventListener('onFormiePageToggle', (e) => {
  const $progressContainer = document.querySelector(
    '[data-fui-progress-container]'
  )
  if ($progressContainer && e.detail.data) {
    const currentPage = parseInt(e.detail.data.nextPageIndex) + 1
    const totalPages = e.detail.data.totalPages
    $progressContainer.textContent = `Page ${currentPage} of ${totalPages}`
  }
})
